import { lazy, Suspense } from "react";
import ProgressBar from "../shared/components/loader/loader";
import { label } from "yet-another-react-lightbox";
import { Navigate, redirect } from "react-router-dom";

// Lazy load components



const Loader = (Component) => (props) => (
    <Suspense fallback={<ProgressBar />}>
        <Component {...props} />
    </Suspense>
);
const Home = Loader(lazy(() => import('./home/index')));
const Aboutus = Loader(lazy(() => import('./about/index')));
const Services = Loader(lazy(() => import('./services/index')));
const TrainingCoaching = Loader(lazy(() => import('./services/training-Coaching/index')));
const InterNationalAdmission = Loader(lazy(() => import('./services/international-admission/index')));
const IndianAdmission = Loader(lazy(() => import('./services/indian-admission/index')));
const Gallery = Loader(lazy(() => import('./gallery/index')));
const CareerLibrary = Loader(lazy(() => import('./career-library/index')));
const Clients = Loader(lazy(() => import('./clients/index')));
const Testimonials = Loader(lazy(() => import('./testimonials/index')));
const Contact = Loader(lazy(() => import('./contact/index')));
const Register = Loader(lazy(() => import('./register/index')));
export const routes = [
    {
        path: "/",
        label: "Home",
        element: <Home />
    },
    {
        path: "aboutus",
        label: "About us",
        element: <Aboutus />,
    },
    {
       path: "services",
        label: "Services",
        element: <Services />,
        children: [
            {
                index: true,

                element: <Navigate to="international-admission" replace />
,
            },
            {
                path: "/services/international-admission",
                label: "International Admission",
                element: <InterNationalAdmission />
            },

            {
                path: "/services/indian-admission",
                label: "Indian Admission",
                element: <IndianAdmission />
            },
            {
                path: "/services/training-coaching",
                label: "Training & Coaching",
                element: <TrainingCoaching />
            },
        ]

    },

    {
        path: "gallery",
        label: "Gallery",
        element: <Gallery />
    },
    {
        path: "career-library",
        label: "Career library",
        element: <CareerLibrary />
    },
    {
        path: "clients",
        label: "Clients",
        element: <Clients />
    },
    {
        path: "testimonials",
        label: "Testimonials",
        element: <Testimonials />
    },
    {
        path: "contact",
        label: "Contact",
        element: <Contact />
    },
    {
        path: "register",
        element: <Register />
    },

];
